import { z } from 'zod';
export const notificationPreferencesSchema = z.object({
    renewalReminders: z.boolean(),
    visitRequests: z.boolean(),
});
//# sourceMappingURL=notification.js.map